module.exports = __webpack_public_path__ + "static/media/1032504550-huge.ba718721.jpg";